/**
 * Signals that onRedirectCallback (main.tsx) has kicked off a full page
 * reload to land the user on their post-login returnTo URL. window.location
 * assignments don't navigate synchronously, so without this flag the app can
 * render the authenticated UI for a frame or two before the reload actually
 * takes effect.
 */
let isReloadingAfterAuthRedirect = false;

export const markAuthRedirectReloadStarted = () => {
  isReloadingAfterAuthRedirect = true;
};

export const isAuthRedirectReloadInProgress = () =>
  isReloadingAfterAuthRedirect;
